import type { MouseEvent, ReactNode } from 'react';
import classnames from 'classnames';
import { never } from '../../../../common/utils/never';
import { IconButton, InlineElement, Link } from '../common';

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function Pagination(props: { children: ReactNode; position?: 'start' | 'center' | 'end' }) {
    return (
        <div className={classnames('layout', props.position ? `${props.position}-justified` : '')}>
            <ul className="pagination">{props.children}</ul>
        </div>
    );
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function PaginationItem(props: { children: ReactNode; isCurrentPage?: boolean; isDisabled?: boolean }) {
    const className = classnames('pagination-item', {
        current: props.isCurrentPage,
        disabled: props.isDisabled,
    });

    return <li className={className}>{props.children}</li>;
}

export type PaginationLinkType = 'first' | 'last' | 'prev' | 'next' | 'ellipsis' | 'pagenumber';

export interface IPaginationLinkProps {
    onClick: (page: number) => Promise<void> | void;
    page: number;
    type: PaginationLinkType;
}

export function PaginationLink(props: IPaginationLinkProps) {
    switch (props.type) {
        case 'first':
            return (
                <IconButton
                    icon="caret-double-left"
                    onClick={handleClick}
                    solid
                />
            );
        case 'last':
            return (
                <IconButton
                    icon="caret-double-right"
                    onClick={handleClick}
                    solid
                />
            );
        case 'prev':
            return (
                <IconButton
                    icon="caret-left"
                    onClick={handleClick}
                    solid
                />
            );
        case 'next':
            return (
                <IconButton
                    icon="caret-right"
                    onClick={handleClick}
                    solid
                />
            );
        case 'ellipsis':
            return <InlineElement className="ellipsis">...</InlineElement>;
        case 'pagenumber':
            return (
                <Link
                    color="secondary"
                    onClick={handleClick}
                    to="#"
                >
                    {props.page}
                </Link>
            );
        default:
            return never(props.type);
    }

    async function handleClick<THtmlElement>(e: MouseEvent<THtmlElement>) {
        e.preventDefault();
        await props.onClick(props.page);
    }
}
